import { create } from 'zustand'
import { withDevTools } from '@/utils/storeDebug'

export type useAuthState = {
  userId: string
}

export type useAuthAction = {
  logout: () => void
  setUserId: (userId: string) => void
}

export const useAuthStore = create<useAuthState & useAuthAction>(
  withDevTools(
    (set) => ({
      userId: '',
      logout: () => {
        set(() => ({ userId: '' }))
      },
      setUserId: (userId) => {
        set(() => ({ userId: userId }))
      },
    }),
    'AuthStore',
  ),
)
